import { mdiAlertCircleOutline } from '@mdi/js';
import React from 'react';
import { BadgeIcon } from './badge-icon';
import * as S from './missing-id-badge.styles';

export interface IMissingIdBadgeProps {
    className?: string;
    children?: React.ReactNode;
}

export const MissingIdBadge: React.FunctionComponent<IMissingIdBadgeProps> = (
    props: IMissingIdBadgeProps,
): React.ReactElement => {
    const { className, children } = props;
    return (
        <S.MissingId className={className}>
            <BadgeIcon path={mdiAlertCircleOutline} />
            <S.Message>{children}</S.Message>
        </S.MissingId>
    );
};
